<template>
    <div width='100%'>
          <!-- features -->
          <h4><b>機能</b></h4>
            <el-table :show-header="false" :data="featureData" :row-key="getRowKeys" :expand-row-keys="expands" @row-click="rowClick">
                <el-table-column type='expand' width='50px'>
                  <template scope="props">
                    <p v-for="(item,index) in props.row.childrenFeatures" :key="index" v-html="item"></p>
                    </template>
                </el-table-column>
                <el-table-column prop='feature' width='750px'>
                  <template slot-scope="scope">
                    <i :class="scope.row.icon"></i>
                    <span style="margin-left: 10px">{{ scope.row.feature }}</span>
                  </template>
                </el-table-column>
            </el-table>

          <!-- Video -->
          <h4><b>デモ</b></h4>
          <object data="http://www.youtube.com/embed/XYOjdKc05kk" width="800" height="600"></object>

          <!-- manual -->
          <h4><b>マニュアル</b></h4>
          <div>
            <el-row gutter="10">
              <el-col :span="12">
                <el-card header="標準版">
                  <el-popover
                    placement="top-start"
                    title="標準版マニュアル"
                    width="1000"
                    trigger="hover">
                    <div class="popover-content" v-html="pdfStd"></div>
                    <a slot="reference">http://www.searchplusplus.jp/manual.pdf</a>
                  </el-popover>
                  <br>
                  <el-tooltip class="item" effect="light" content="別ウィンドウで閲覧" placement="bottom">
                    <a href="http://www.searchplusplus.jp/manual.pdf" target="blank"><i class="el-icon-document openIcon"></i></a>
                  </el-tooltip>
                </el-card>
              </el-col>
              <el-col :span="12">
                <el-card id="proManual" header="Pro版">
                  <el-popover
                    placement="top-start"
                    title="Pro版マニュアル"
                    width="1000"
                    trigger="hover">
                    <div class="popover-content" v-html="pdfPro"></div>
                    <a slot="reference">http://www.searchplusplus.jp/manual_pro.pdf</a>
                  </el-popover>
                  <br>
                  <el-tooltip class="item" effect="light" content="別ウィンドウで閲覧" placement="bottom">
                    <a href="http://www.searchplusplus.jp/manual_pro.pdf" target="blank"><i class="el-icon-document-add openIcon"></i></a>
                  </el-tooltip>
                </el-card>
              </el-col>
            </el-row>
          </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      featureData: [{
        id: '1',
        icon: 'el-icon-magic-stick',
        feature: '新旧MSOfficeフォーマットはもちろん、幅広い範囲のファイル種類をサポートしています．',
        childrenFeatures: [
          'MS PowerPoint(PPT、PPTX)',
          'MS Word(RTF,DOC,DOCX)',
          'MS Excel(XLS, XLSX)',
          'MS Outlook(MSG,EML)',
          'MS Visio(VSD)',
          'HTML,HTM',
          'Open Office Format(ODTなど)',
          '一太郎',
          'Fuji　Xerox　Docuworks（IFILTERのインストール必要）',
          '各種テキストファイル（*.rtf, *.txt,*.log,*.java,*.cpp,*.c,*.bat,*.config)',
          'PDF <a href="http://faq.epson.jp/faq/00/app/servlet/relatedqa?QID=003133" target="blank">「資料をスキャンしてPDFとして保存する場合、テキスト検索できるためOCRしてください」</a>'
        ]
      }, {
        id: '2',
        icon: 'el-icon-magic-stick',
        feature: '簡単にインストールできます',
        childrenFeatures: ['標準版は解凍だけで、Pro版は環境設定のため、本体実行前に、同梱のStartup.exeを実行する必要です．']
      }, {
        id: '3',
        icon: 'el-icon-magic-stick',
        feature: '指定したフォルダーの下にすべてのファイルに対して、インデックスを作成してから検索できます．',
        childrenFeatures: ['常駐モードでインデックスの自動更新ができます．非常駐モードでは「即更新」ボタンを押すと差分だけを更新します']
      }, {
        id: '4',
        icon: 'el-icon-magic-stick',
        feature: '検索結果ファイルに対して、各種レビューが可能です。',
        childrenFeatures: ['該当行だけではなく、抜粋もファイルの内容も閲覧が可能です']
      }
      ],
      pdfStd: "<embed src='http://www.searchplusplus.jp/manual.pdf' type='application/pdf' width='100%' height='800px'>",
      pdfPro: "<embed src='http://www.searchplusplus.jp/manual_pro.pdf' type='application/pdf' width='100%' height='800px'>",
      expands: []
    }
  },
  methods: {
    getRowKeys (row) {
      return row.id
    },
    rowClick (row) {
      if (row.id === this.expands[0]) { // collapsed
        this.expands = []
      } else { // expand
        this.expands = []
        this.expands.push(row.id)
      }
    }
  }
}
</script>

<style scoped>
.el-table{
  font-size: 16px;
}

.el-table__header {
  width: 100% !important;
}

.el-table__body {
  width: 100% !important;
}

.el-card {
  height: 140px;
}

.openIcon {
  font-size: 24px;
}
</style>
